import Loader from 'components/Loader';
import React, { lazy, ReactNode, Suspense } from 'react';

interface LoadableConfigTypes {
  fallback?: ReactNode;
  isPageLoad?: Boolean;
}

const loadable = <T=any,>(
  importFunc: () => Promise<{ default: React.ComponentType<any> }>,
  { fallback = null, isPageLoad = false }: LoadableConfigTypes = {
    fallback: null,
    isPageLoad: false,
  },
) => {
  const LazyComponent = lazy(importFunc);

  let suspenseFallback: ReactNode = fallback;
  if (isPageLoad) {
    suspenseFallback = <Loader active />;
  }

  return (props:T) => (
    <Suspense fallback={suspenseFallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default loadable;
